import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: "app-dialog-confirm",

  templateUrl: "./dialog-confirm.component.html",
  styleUrl: "./dialog-confirm.component.css",
})
export class DialogConfirmComponent {
  title: string;
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  
  constructor(
    private readonly router: Router, 
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.title = data.title || 'Are you sure?';
      this.message = data.message || 'This action cannot be undone.';
      this.confirmButtonText = data.confirmButtonText || 'CONFIRM';
      this.cancelButtonText = data.cancelButtonText || 'CANCEL';
  }
  
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  redirectToAnotherRoute() {
    this.dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate(["login"]);
    });

    this.dialogRef.close(true); 
  }
}
